import { render, staticRenderFns } from "./commentSuccess.vue?vue&type=template&id=2eaffbb0&scoped=true&"
import script from "./commentSuccess.vue?vue&type=script&lang=js&"
export * from "./commentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./commentSuccess.vue?vue&type=style&index=0&id=2eaffbb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaffbb0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eaffbb0')) {
      api.createRecord('2eaffbb0', component.options)
    } else {
      api.reload('2eaffbb0', component.options)
    }
    module.hot.accept("./commentSuccess.vue?vue&type=template&id=2eaffbb0&scoped=true&", function () {
      api.rerender('2eaffbb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commentSuccess.vue"
export default component.exports